// common imports

import 'popper.js';
import 'bootstrap';
import * as BootstrapDialog from 'bootstrap4-dialog';
import * as BootstrapDatepicker from 'bootstrap-datepicker';
import * as Ladda from 'ladda';
import * as Cookies from 'js-cookie';
import Glide from '@glidejs/glide';
import { LSUtils } from './utils.js';
import { LSCHWeb } from './chWeb.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap4-dialog/dist/css/bootstrap-dialog.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'ladda/dist/ladda-themeless.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import '../css/3rd-party.css';
import '../css/bs-overrides.css';
import '../css/layouts.css';
import '../css/text.css';
window.BootstrapDialog = BootstrapDialog;
window.BootstrapDatepicker = BootstrapDatepicker;
window.Ladda = Ladda;
window.Cookies = Cookies;
window.Glide = Glide;
window.LSUtils = LSUtils;
window.LSCHWeb = LSCHWeb;

// for bwd compatibility
window.Utils = LSUtils;